module.exports = __webpack_public_path__ + "static/media/double-park.83e73b44.jpg";